<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()" fill="clear">
        <ion-icon class="white-arrow" slot="icon-only" src="assets/>Blanc.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{'MODALS.SCANHELP.TITLE'|translate}}
    </ion-title>
    <ion-icon size="large" slot="end" class="ion-no-margin ion-no-padding" name="help-circle-outline"></ion-icon>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="rounded">
    <ion-row>
      <ion-col class="ion-text-center">
        <img class="input-logos ion-padding ion-margin" src="assets/cylindre_innovel_activation2.svg" />
      </ion-col>
    </ion-row>
    <ion-row class="ion-padding ion-margin">
      <ion-col class="ion-text-center">
        <ion-label>
          <p>{{'MODALS.SCANHELP.TXT'|translate}}</p>
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-row class="ion-text-center">
    <ion-col>
      <ion-button (click)="close()">{{'MODALS.SCANHELP.UNDERSTOOD'|translate}}</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>